module.exports = __webpack_public_path__ + "static/media/zenodo-select-upload.c78e55f5.png";